export default {
    container: {
        position: 'absolute',
        zIndex: 0,
        width: '100%',
        height: '100%',
        background: '#000'
    },
    dialogContainer: {
        width: '100%',
        height: '100%'
    },
    message: {
        position: 'absolute',
        margin: '0 auto',
        background: 'rgba(0,0,0,0.7)',
        padding: 10,
        top: '50%',
        transform: 'translateY(-50%)',
        width: '100%',
        height: 'auto',
        color: '#fff',
        lineHeight: 1.3,
        textAlign: 'center'
    }
};



// WEBPACK FOOTER //
// ./app/webapp/syndicated/SyndicatedPlayer/style.js